<template>
  <footer class="footer">
    <div class="container-fluid d-flex flex-wrap justify-content-between">
      <nav>
        <ul class="footer-menu">
          <li>
              <span class="btn btn-link">
             {{ version }}

              </span>
          </li>
        </ul>
      </nav>
      <div class="copyright">
 
      </div>
    </div>
  </footer>
</template>
<script>
  export default {
     data(){
         return {
             version: process.env.VUE_APP_VERSION
         }
     }
  }

</script>
<style>

</style>
